(() => {
  const initializeLazyYoutubeEmbeds = () => {
    document.querySelectorAll('iframe[data-youtube-src]').forEach((iframe) => {
      const source = iframe.dataset.youtubeSrc;
      if (!source) return;

      let videoId = '';
      try {
        const url = new URL(source, window.location.origin);
        videoId = url.pathname.split('/').filter(Boolean).pop() || '';
      } catch (error) {
        return;
      }

      const wrapper = document.createElement('div');
      wrapper.className = 'lazy-youtube';
      wrapper.style.height = iframe.getAttribute('height') || '400px';

      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'lazy-youtube__button';
      button.setAttribute('aria-label', `Play video: ${iframe.title || 'YouTube video'}`);

      const posterSource = `https://i.ytimg.com/vi/${encodeURIComponent(videoId)}/maxresdefault.jpg`;
      const fallbackPosterSource = `https://i.ytimg.com/vi/${encodeURIComponent(videoId)}/hqdefault.jpg`;
      button.style.setProperty('--lazy-youtube-poster', `url("${posterSource}")`);

      const poster = document.createElement('img');
      poster.className = 'lazy-youtube__poster';
      poster.src = posterSource;
      poster.alt = '';
      poster.loading = 'lazy';
      poster.decoding = 'async';
      poster.width = 1280;
      poster.height = 720;
      poster.addEventListener(
        'error',
        () => {
          if (poster.src === fallbackPosterSource) return;
          poster.src = fallbackPosterSource;
          button.style.setProperty('--lazy-youtube-poster', `url("${fallbackPosterSource}")`);
        },
        { once: true }
      );

      const overlay = document.createElement('span');
      overlay.className = 'lazy-youtube__overlay';
      overlay.setAttribute('aria-hidden', 'true');

      const brand = document.createElement('span');
      brand.className = 'lazy-youtube__brand';
      brand.setAttribute('aria-hidden', 'true');
      brand.innerHTML =
        '<svg viewBox="0 0 24 24" width="16" height="16"><circle cx="12" cy="12" r="9" fill="currentColor"/><path d="M8.5 12.3 11 14.8l4.8-5.3" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg><span>HOMEAX</span>';

      const playIcon = document.createElement('span');
      playIcon.className = 'lazy-youtube__play';
      playIcon.setAttribute('aria-hidden', 'true');
      playIcon.innerHTML =
        '<svg viewBox="0 0 24 24" width="40" height="40"><path d="m9 7 8 5-8 5V7Z" fill="currentColor"/></svg>';

      const caption = document.createElement('span');
      caption.className = 'lazy-youtube__caption';
      caption.setAttribute('aria-hidden', 'true');
      caption.innerHTML =
        '<strong>Watch product video</strong><span>See it in action</span>';

      button.append(poster, overlay, brand, playIcon, caption);
      wrapper.append(button);
      iframe.replaceWith(wrapper);

      button.addEventListener(
        'click',
        () => {
          const separator = source.includes('?') ? '&' : '?';
          iframe.src = `${source}${separator}autoplay=1`;
          iframe.loading = 'lazy';
          iframe.allow = 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture';
          iframe.allowFullscreen = true;
          button.replaceWith(iframe);
        },
        { once: true }
      );
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeLazyYoutubeEmbeds, { once: true });
  } else {
    initializeLazyYoutubeEmbeds();
  }
})();
